import { instance as axios, setJwtToken } from "config/axiosInstance";

// -------------------fetch-list----------------------
export const subAdminListApi = async () => {
  return axios.get(`/admin/subadmin`, setJwtToken());
};
// -------------------change-password-APi----------------------
export const changePasswordSubAdminApi = async (data) => {
  return axios.put(`/admin/subadmin/change/password`,data, setJwtToken());
};
